import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconColumns = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("g", {
      clipPath: "url(#Columns_svg__clip0_32724_402407)",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      children: /*#__PURE__*/jsx("path", {
        d: "M3.75.747h-1.5a1.5 1.5 0 00-1.5 1.5v19.5a1.5 1.5 0 001.5 1.5h1.5a1.5 1.5 0 001.5-1.5v-19.5a1.5 1.5 0 00-1.5-1.5zM12.751.747h-1.5a1.5 1.5 0 00-1.5 1.5v19.5a1.5 1.5 0 001.5 1.5h1.5a1.5 1.5 0 001.5-1.5v-19.5a1.5 1.5 0 00-1.5-1.5zM21.75.747h-1.5a1.5 1.5 0 00-1.5 1.5v19.5a1.5 1.5 0 001.5 1.5h1.5a1.5 1.5 0 001.5-1.5v-19.5a1.5 1.5 0 00-1.5-1.5z"
      })
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("clipPath", {
        id: "Columns_svg__clip0_32724_402407",
        children: /*#__PURE__*/jsx("path", {
          fill: "#FFF",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  }));
});
IconColumns.displayName = "IconColumns";

export { IconColumns };
